import { SerializedStyles } from '@emotion/react';
import { useMultiLocationUtils } from '@frontend/payments-hooks';
import { useAppScopeStore } from '@frontend/scope';
import { Text } from '@frontend/design-system';

export const PrintHeader = ({ style }: { style?: SerializedStyles }) => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  const { getLocationName } = useMultiLocationUtils();

  return (
    <Text size='large' weight='bold' css={style}>
      {locationIds.map((locationId) => getLocationName(locationId)).join(', ')}
    </Text>
  );
};
